import dynamic from 'next/dynamic';
import React, { useMemo } from 'react';

import { ComponentsContext } from '@/core/lib/components/components.context';
import AdLinkWithStatsApiCall from '@/next/components/Ad/AdLinkWithStatsApiCall';
import AppleButton from '@/next/components/AppleButton';
import Content from '@/next/components/Content';
import Draggable from '@/next/components/Draggable';
import FacebookButton from '@/next/components/FacebookButton';
import Footer from '@/next/components/Footer';
import GoogleButton from '@/next/components/GoogleButton';
import Head from '@/next/components/Head';
import MetaTitle from '@/next/components/MetaTitle';
import Page from '@/next/components/Page';
import PreFooter from '@/next/components/PreFooter';
import Refresher from '@/next/components/Refresher';

const DonationCardState = dynamic(() => import('@/core/components/DonationCard/DonationCardState'), { ssr: false });

const ComponentsProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
  const value = useMemo(
    () => ({
      Page,
      Content,
      AppleButton,
      FacebookButton,
      GoogleButton,
      MetaTitle,
      Footer,
      Head,
      DonationCardState,
      PreFooter,
      Refresher,
      useBackButton: () => {},
      AdLinkWithStatsApiCall,
      Draggable,
    }),
    [],
  );

  return <ComponentsContext.Provider value={value}>{children}</ComponentsContext.Provider>;
};

export default ComponentsProvider;
